

<button color="accent"
		mat-fab mat-dialog-close
		cdkFocusInitial
		style="position: absolute; inset-block-start: calc(15px + env(safe-area-inset-top)); inset-inline-end: 15px; z-index: 1">
	<mat-icon>close</mat-icon>
</button>

<iframe class="embed-responsive-item"
		style="width: 100vw; height: 100vh;"
		(load)="onFrameLoaded($event)"
		[src]="this.trustedIframeUrl"></iframe>
